import React from 'react';
import FaqItem from 'slickpay/online/FaqItem.component';

import CurrencySign from 'components/price/CurrencySign.component';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './WebsiteTips.module.scss';

const TEXT_1 = (
  <div className={CN.description}>Websites are the way people find your business nowadays and often the first thing they search for. If they can't find you, they simply won't visit you.</div>
);

const TEXT_2 = (
  <div className={CN.description}>
    Not only do we know this industry inside out, we also understand the business whose website we’re building. We've listened to feedback from 1000s of clients who were dissatisfied with the website
    services that were out there and created this service to fulfill your specific needs as a Hair/Beauty business. As your booking service provider, we are the only company that can build you an
    integrated website that can update itself, use industry data and knowledge of your business to get your website ranking highly on google, and offer all inclusive pricing packages all while making
    you a huge return on your investment.
  </div>
);

const TEXT_3 = (
  <div className={CN.description}>
    Don't worry if you're not good with tech, because luckily we are ! All you have to do is send us some information about you and the team and provide some photos of your salon - then sit back and
    let us do the rest.{' '}
  </div>
);

const TEXT_4 = <div className={CN.description}>Our lead time is from 24 hours. That means, if you submitted today, we could have your Slick website up and running for you tomorrow!</div>;

const TEXT_5 = (
  <div className={CN.description}>
    Our websites feature an automatic integration with your Slick account, which means when you update in Slick that features on your website (your Opening Hours, Address, Services & Prices, Staff
    Members & Titles, Email Address, Phone Number & Cancellation Policy). This means you don't have to wait for your IT person to return your calls so they can put the changes through, or pay extra
    everytime for a small tweak on your site!
  </div>
);

const TEXT_6 = (
  <div className={CN.description}>
    When you change information in your Slick account, it will be connected to where that information is on your website - our smart site will then know to update and show the new information. We will
    contact you if there are manual changes that need to be made in addition to the change - for example, if we see you've moved locations, we will reach out and ask if you want new photos. Even
    manual changes are nearly instant as we have a 72 hour window within which these happen. Pretty cool, huh?
  </div>
);
const TEXT_7 = (
  <div className={CN.description}>
    To offer you industry leading prices, we take care of and include all the maintenance related aspects of owning a website in our monthly fee. This fee covers the cost of security, hosting, domain
    maintenance, the automatic integration, and access to technical support that includes an on hand website expert. On the pro plan and above, this also covers SEO and maintenance and updating of
    dynamic pages like the blog and offers page. This means you don't have to worry about all the moving parts and enjoy a simple monthly subscription to cover services that have a combined value of
    up to <CurrencySign />
    500/month.
  </div>
);
const TEXT_8 = (
  <div className={CN.description}>
    The support you get from Slick's website creation service is an extension of the support you get from your existing Slick family - Customer Support and your Business Coach. And now you've got your
    website expert on hand to help too, as well as a large library of video tutorials!
  </div>
);
const TEXT_9 = (
  <div className={CN.description}>
    No. Our websites run on a monthly subscription, meaning you pay a one time set up fee and from then on a small monthly fee to cover all Website related costs. You can cancel the subscription at
    any time.
  </div>
);
const TEXT_10 = (
  <div className={CN.description}>
    SEO stands for Search Engine Optimisation. It is important because this is how you ensure people find your business's website when they type in 'Salons near me' or 'Salons in [name of their
    town]'. We can improve your SEO, using our industry expertise and knowledge of your business, by tagging your website with relevant keywords, to ensure that people can find you when they search
    for businesses in your area.
  </div>
);

const WebsiteTips = ({ tag }) => (
  <div data-bem="WebsiteTips" className={CN.component} data-tag={fromAnyToTrimmed(tag)}>
    <div className={CN.title}>Website FAQs:</div>
    <div className={CN.container} data-bem="WebsiteTips__container">
      <FaqItem title="Why is having a website essential for my business?" description={TEXT_1} isOpen variant="full" />
      <FaqItem title="I already have a website. What makes a Slick different?" description={TEXT_2} variant="full" />
      <FaqItem title="I’m not good with tech. How much work will I have to do?" description={TEXT_3} variant="full" />
      <FaqItem title="I need a website ASAP. How long does it take to go live?" description={TEXT_4} variant="full" />
      <FaqItem title="I’m struggling to get anything updated on my website. How do you deal with this?" description={TEXT_5} variant="full" />
      <FaqItem title="How does the automatic integration work?" description={TEXT_6} variant="full" />
      <FaqItem title="What is the monthly fee for?" description={TEXT_7} variant="full" />
      <FaqItem title="Who do I talk to when I need support?" description={TEXT_8} variant="full" />
      <FaqItem title="Is there a contract?" description={TEXT_9} variant="full" />
      <FaqItem title="What is SEO and why is it important?" description={TEXT_10} variant="full" />
    </div>
  </div>
);
export default WebsiteTips;
